import { Component } from '@angular/core';
import { LLCFunctions } from '@functions/llc.service';
import { take } from 'rxjs/operators';

@Component({
	selector: 'app-resources',
	templateUrl: './resources.component.html',
	styleUrls: ['./resources.component.scss'],
	standalone: false,
})
export class ResourcesComponent {
	public result;
	public selected: 'institutions' | 'configs' | 'payeeTypes' | 'all' =
		'institutions';

	constructor(private func: LLCFunctions) {}

	async getData() {
		try {
			this.result = await this.func.getResource().pipe(take(1)).toPromise();
		} catch (err) {
			console.log('Unable to fetch llc resources', err);
		}
	}
}
